var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessengerQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1155 1155",
    style: {
      enableBackground: "new 0 0 1155 1155"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1155,
    height: 1155
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,0) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,770) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,70) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,840) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerQrCode);
export default __webpack_public_path__ + "static/media/messenger_qr_code.badd67f73d45f420b6accd6a8a2f5544.svg";
export { ForwardRef as ReactComponent };